/* Zampa d'Oro · home social: titolo che cambia, prima e dopo, Titolatore */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Parola che cambia nel titolo della hero
  const initSwap = (el) => {
    const words = (el.dataset.words || '').split('|').map((w) => w.trim()).filter(Boolean);
    if (words.length < 2 || reduceMotion) return;
    let i = 0;
    const timer = setInterval(() => {
      if (!el.isConnected) return clearInterval(timer);
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(() => {
        i = (i + 1) % words.length;
        el.textContent = words[i];
        el.classList.remove('is-out');
        el.classList.add('is-in');
      }, 280);
    }, 2200);
  };

  // Prima e dopo da trascinare
  const initCompare = (ba) => {
    const range = ba.querySelector('input[type="range"]');
    const hint = ba.querySelector('.zs-ba__hint');
    range.addEventListener('input', () => {
      ba.style.setProperty('--x', range.value + '%');
      if (hint) hint.remove();
    });
  };

  // Il Titolatore: titolo, feudo e motto, più la storia 1080×1920 da condividere
  const TITOLI = {
    m: ['Duca', 'Marchese', 'Conte', 'Barone', 'Granduca', 'Principe', 'Visconte', 'Arciduca'],
    f: ['Duchessa', 'Marchesa', 'Contessa', 'Baronessa', 'Granduchessa', 'Principessa', 'Viscontessa', 'Arciduchessa']
  };
  const POTERI = {
    dorme: { label: 'Dorme ovunque', feudi: ['del Divano Grande', 'delle Coperte Calde', 'del Cuscino Rubato', 'della Pennichella Eterna'], motti: ['Dormio ergo sum', 'Nessuna sveglia mi governa', 'Il divano è mio per diritto divino'] },
    goloso: { label: 'Ladro di cibo', feudi: ["della Crocchetta d'Oro", 'del Frigorifero', 'della Briciola Caduta', 'del Prosciutto Conteso'], motti: ['Veni, vidi, mangiavi', 'Ciò che cade è mio', 'Il piatto altrui è il mio feudo'] },
    drama: { label: 'Drama queen', feudi: ['dei Mille Capricci', 'del Sospiro Teatrale', 'della Porta Chiusa', 'dello Sguardo Offeso'], motti: ['Offeso, ma con stile', 'Nessuno mi capisce', 'Pretendo udienza. Subito.'] },
    guardia: { label: 'Fa la guardia', feudi: ['del Campanello', 'della Finestra sul Cortile', 'del Postino Temuto', 'dei Confini Sorvegliati'], motti: ['Vigilo mentre voi dormite', 'Nessun corriere passerà', 'Sorveglio, dunque sono'] },
    coccole: { label: 'Coccolone', feudi: ['delle Grattatine', 'del Grembo Caldo', 'delle Fusa Infinite', 'del Divano Condiviso'], motti: ['Ama e fatti grattare', 'La pancia è un dono', 'Coccole o rivolta'] },
    esplora: { label: 'Esploratore', feudi: ['del Parco Comunale', 'delle Pozzanghere', 'del Bastone Perduto', 'dei Cespugli Ignoti'], motti: ['Il fango è gloria', 'Ogni foglia va annusata', 'Più lontano, più fango'] }
  };

  // Stesso nome e stessi tratti danno sempre lo stesso titolo: così diventa "suo"
  const hash = (s) => {
    let h = 2166136261;
    for (const c of s) { h ^= c.charCodeAt(0); h = Math.imul(h, 16777619); }
    return h >>> 0;
  };

  const loadImg = (src, cors) => new Promise((ok, ko) => {
    const img = new Image();
    if (cors) img.crossOrigin = 'anonymous';
    img.onload = () => ok(img);
    img.onerror = ko;
    img.src = src;
  });

  const initTitolatore = (root) => {
    const form = root.querySelector('[data-zs-form]');
    const canvas = root.querySelector('[data-zs-canvas]');
    const toast = root.querySelector('[data-zs-toast]');
    const ctx = canvas.getContext('2d');
    const handle = root.dataset.handle || '';
    const hashtag = root.dataset.hashtag || '';
    const productUrl = root.dataset.productUrl || '';
    const site = root.dataset.site || '';
    const cta = root.querySelector('[data-zs-buy]');
    let foto = null;

    const chips = form.querySelector('[data-zs-chips]');
    Object.entries(POTERI).forEach(([k, p], i) => {
      chips.insertAdjacentHTML('beforeend', `<label class="zs-chip"><input type="radio" name="potere" value="${k}"${i === 0 ? ' checked' : ''}><span>${p.label}</span></label>`);
    });

    const say = (t) => {
      toast.textContent = t;
      toast.classList.add('is-on');
      clearTimeout(say.t);
      say.t = setTimeout(() => toast.classList.remove('is-on'), 2600);
    };

    const stato = () => {
      const d = new FormData(form);
      const raw = String(d.get('nome') || '').trim().replace(/\s+/g, ' ') || 'Biscotto';
      const nome = raw.charAt(0).toUpperCase() + raw.slice(1);
      const genere = d.get('genere') === 'f' ? 'f' : 'm';
      const potere = POTERI[d.get('potere')] ? d.get('potere') : 'dorme';
      const p = POTERI[potere];
      const h = hash(nome.toLowerCase() + potere + genere);
      return {
        nome, genere, potere,
        tipo: d.get('tipo') === 'gatto' ? 'gatto' : 'cane',
        titolo: TITOLI[genere][h % TITOLI[genere].length],
        feudo: p.feudi[(h >>> 4) % p.feudi.length],
        motto: p.motti[(h >>> 9) % p.motti.length]
      };
    };

    const roundRect = (x, y, w, h, r) => {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    };
    const fit = (text, font, max, size) => {
      do { ctx.font = font.replace('{s}', size); size -= 4; } while (ctx.measureText(text).width > max && size > 30);
    };
    const wrapLines = (text, max) => {
      const lines = [];
      let line = '';
      text.split(' ').forEach((w) => {
        const t = line ? line + ' ' + w : w;
        if (ctx.measureText(t).width > max && line) { lines.push(line); line = w; } else line = t;
      });
      lines.push(line);
      return lines;
    };

    const disegna = () => {
      const s = stato();
      root.querySelector('[data-zs-title]').textContent = `Sua Eccellenza ${s.nome}, ${s.titolo} ${s.feudo}`;
      root.querySelector('[data-zs-motto]').textContent = `«${s.motto}»`;
      if (cta && productUrl) {
        const u = new URL(productUrl, location.origin);
        u.searchParams.set('nome', s.nome);
        u.searchParams.set('titolo', `${s.titolo} ${s.feudo}`);
        cta.href = u.pathname + u.search;
      }

      const W = 1080, H = 1920;
      ctx.fillStyle = '#fff3e0';
      ctx.fillRect(0, 0, W, H);
      ctx.textAlign = 'center';
      ctx.fillStyle = '#17110c';
      ctx.font = '800 34px "Bricolage Grotesque"';
      ctx.fillText('ALBO DEI NOBILI  ✦  ZAMPA D’ORO', W / 2, 120);

      // Cornice con la foto
      const fx = 130, fy = 180, fw = 820, fh = 980;
      ctx.save();
      ctx.translate(W / 2, fy + fh / 2); ctx.rotate(-0.025); ctx.translate(-W / 2, -(fy + fh / 2));
      ctx.fillStyle = '#17110c'; roundRect(fx + 18, fy + 18, fw, fh, 40); ctx.fill();
      ctx.fillStyle = '#ffc23d'; roundRect(fx, fy, fw, fh, 40); ctx.fill();
      ctx.lineWidth = 6; ctx.strokeStyle = '#17110c'; ctx.stroke();
      ctx.save();
      roundRect(fx + 34, fy + 34, fw - 68, fh - 68, 22); ctx.clip();
      if (foto) {
        const r = Math.max((fw - 68) / foto.width, (fh - 68) / foto.height);
        const iw = foto.width * r, ih = foto.height * r;
        ctx.drawImage(foto, fx + 34 + (fw - 68 - iw) / 2, fy + 34 + (fh - 68 - ih) / 2.6, iw, ih);
      } else {
        ctx.fillStyle = '#cbb8ff'; ctx.fillRect(fx, fy, fw, fh);
      }
      ctx.restore();
      ctx.lineWidth = 6; roundRect(fx + 34, fy + 34, fw - 68, fh - 68, 22); ctx.stroke();
      ctx.restore();

      // Bollino
      ctx.save();
      ctx.translate(900, 230); ctx.rotate(0.22);
      ctx.fillStyle = '#ff4a1c'; ctx.beginPath(); ctx.arc(0, 0, 112, 0, Math.PI * 2); ctx.fill();
      ctx.lineWidth = 6; ctx.strokeStyle = '#17110c'; ctx.stroke();
      ctx.fillStyle = '#fff'; ctx.font = '800 34px "Bricolage Grotesque"';
      ctx.fillText('NOMINA', 0, -6); ctx.fillText('UFFICIALE', 0, 34);
      ctx.restore();

      // Testi
      ctx.fillStyle = '#ff4a1c'; ctx.font = 'italic 64px "Instrument Serif"';
      ctx.fillText('Sua Eccellenza', W / 2, 1290);
      ctx.fillStyle = '#17110c';
      fit(s.nome, '800 {s}px "Bricolage Grotesque"', 900, 168);
      ctx.fillText(s.nome, W / 2, 1440);
      ctx.font = '700 62px "Bricolage Grotesque"';
      const lines = wrapLines(`${s.titolo} ${s.feudo}`, 900).slice(0, 2);
      lines.forEach((l, i) => ctx.fillText(l, W / 2, 1530 + i * 72));
      ctx.fillStyle = '#4a3d33'; ctx.font = 'italic 56px "Instrument Serif"';
      ctx.fillText(`«${s.motto}»`, W / 2, 1530 + lines.length * 72 + 50);

      // Piede: è qui che la storia riporta gente al negozio
      ctx.fillStyle = '#17110c'; ctx.fillRect(0, 1760, W, 160);
      ctx.fillStyle = '#ffc23d'; ctx.font = '800 44px "Bricolage Grotesque"';
      ctx.fillText(`E il tuo ${s.tipo} che nobile è?`, W / 2, 1830);
      ctx.fillStyle = '#fff3e0'; ctx.font = '600 32px "Bricolage Grotesque"';
      ctx.fillText([handle, hashtag].filter(Boolean).join('  ·  '), W / 2, 1880);
    };

    const blob = () => new Promise((ok, ko) => {
      try { canvas.toBlob((b) => (b ? ok(b) : ko(new Error('vuoto'))), 'image/png'); } catch (err) { ko(err); }
    });

    form.addEventListener('input', disegna);
    form.addEventListener('submit', (e) => e.preventDefault());

    form.querySelector('[data-zs-file]').addEventListener('change', async (e) => {
      const f = e.target.files[0];
      if (!f) return;
      try {
        foto = await loadImg(URL.createObjectURL(f), false);
        root.querySelector('[data-zs-up]').textContent = 'Foto aggiunta ✓';
        disegna();
      } catch {
        say('Questa foto non si apre, provane un’altra');
      }
    });

    root.querySelector('[data-zs-share]').addEventListener('click', async () => {
      const s = stato();
      let b;
      try { b = await blob(); } catch { say('Aggiungi la sua foto per scaricare la storia'); return; }
      const file = new File([b], `nomina-${s.nome.toLowerCase().replace(/[^a-z0-9]+/g, '-')}.png`, { type: 'image/png' });
      const text = `${s.nome} è ufficialmente ${s.titolo} ${s.feudo} \u{1F451} ${hashtag}`.trim();
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try { await navigator.share({ files: [file], text }); } catch { /* condivisione annullata */ }
      } else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.download = file.name;
        a.click();
        say(handle ? `Storia scaricata: postala e tagga ${handle}` : 'Storia scaricata: ora postala');
      }
    });

    root.querySelector('[data-zs-challenge]').addEventListener('click', async () => {
      const s = stato();
      const url = site || `${location.origin}/#titolatore`;
      const nominato = s.genere === 'f' ? 'stata nominata' : 'stato nominato';
      const text = `${s.nome} è ${nominato} ${s.titolo} ${s.feudo} \u{1F451} Scommetto che il tuo ${s.tipo} non arriva a tanto:`;
      if (navigator.share) {
        try { await navigator.share({ text, url }); } catch { /* condivisione annullata */ }
      } else {
        try { await navigator.clipboard.writeText(`${text} ${url}`); say('Link copiato: mandalo a chi vuoi sfidare'); } catch { say(url); }
      }
    });

    const fonts = document.fonts
      ? document.fonts.load('800 60px "Bricolage Grotesque"').then(() => document.fonts.load('italic 60px "Instrument Serif"'))
      : Promise.resolve();
    fonts.catch(() => {}).finally(async () => {
      disegna();
      const def = root.dataset.defaultImg;
      if (!def || foto) return;
      try { foto = foto || await loadImg(def, true); disegna(); } catch { /* resta il fondo lilla */ }
    });
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-zs-swap]').forEach(initSwap);
    scope.querySelectorAll('[data-zs-ba]').forEach(initCompare);
    scope.querySelectorAll('[data-zs-titolatore]').forEach(initTitolatore);
  };

  init(document);
  // Editor del tema: la sezione ricaricata va riavviata
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
